import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
// @ts-nocheck
// tslint:disable
export var Blob = /*#__PURE__*/function () {
  /**
   *
   * @param buffers only support zero index
   * @param type mimetype image/png image/webp...
   */
  function Blob(buffers, type) {
    _classCallCheck(this, Blob);

    this.buffers = buffers;
    this.type = type;
  }

  _createClass(Blob, [{
    key: "arraybuffer",
    value: function arraybuffer() {
      return Promise.resolve(this.buffers[0]);
    }
  }, {
    key: "stream",
    value: function stream() {
      throw new Error('not implemented');
    }
  }, {
    key: "text",
    value: function text() {
      throw new Error('not implemented');
    }
  }, {
    key: "slice",
    value: function slice(start, end, contentType) {
      throw new Error('not implemented');
    }
  }]);

  return Blob;
}();